<dialog-header [dialogRef]="dialogRef" headerKey="ORDERS.ADD_INSPECTORS"></dialog-header>
<div mat-dialog-content>
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <mat-form-field>
      <mat-label>{{ 'ORDERS.INSPECTORS' | translate }}</mat-label>
      <mat-select formControlName="users" [multiple]="true">
        <mat-option *ngFor="let user of data.users" [value]="user.id">
          {{ getUserLabel(user) }}
        </mat-option>
      </mat-select>
      <mat-error>{{ 'FIELD_ERROR.INSPECTORS' | translate }}</mat-error>
    </mat-form-field>
    <dialog-buttons submitLabel="SAVE"></dialog-buttons>
  </form>
</div>


